import { render, staticRenderFns } from "./overlay-controls-upper.vue?vue&type=template&id=7c08ec96"
import script from "./overlay-controls-upper.vue?vue&type=script&lang=js"
export * from "./overlay-controls-upper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports